import React from "react";
import { Col, Row } from "react-bootstrap";

const PerformanceStatusGuide: React.FC = () => {
  const guideItems = [
    {
      title: "Top Performer",
      description:
        "Consistently exceeds targets with strong high-intent conversions and a very low rejection rate.",
      badgeClass: "chip--status-top",
      iconClass: "fas fa-trophy",
      iconModifier: "guide-item__icon--top",
    },
    {
      title: "On Track",
      description:
        "Meets expected performance targets with stable lead handling and healthy conversion results.",
      badgeClass: "chip--status-good",
      iconClass: "fas fa-check-circle",
      iconModifier: "guide-item__icon--good",
    },
    {
      title: "Needs Attention",
      description:
        "Performance is below target or inconsistent and may require coaching or follow-up support.",
      badgeClass: "chip--status-below",
      iconClass: "fas fa-exclamation-triangle",
      iconModifier: "guide-item__icon--below",
    },
  ];

  return (
    <div className="guide-row content-wrapper mt-4">
      <div className="guide-row__header">
        <h3>Performance Status Guide</h3>

        <i
          className="far fa-info-circle guide-row__info-icon"
          aria-hidden="true"
        />
      </div>

      <Row className="g-3">
        {guideItems.map((item) => (
          <Col key={item.title} xs={12} md={4}>
            <div className="guide-item">
              <div
                className={`guide-item__icon ${item.iconModifier}`}
                aria-hidden="true"
              >
                <i className={item.iconClass} />
              </div>

              <div className="guide-item__content">
                <div
                  className={`performance-badge chip chip--soft ${item.badgeClass}`}
                >
                  {item.title}
                </div>

                <p>{item.description}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PerformanceStatusGuide;
